module.exports = __webpack_public_path__ + "img/alturos-logo.77fb2069.jpg";